import { createInsurer, updateInsurer as editInsurer, getInsurers, getInsurersPremium, getOtherRates } from '../utils/apiService';

export const LIST_OTHER_RATES = 'insurer/LIST_OTHER_RATES';
export const LIST_OTHER_RATES_PENDING = 'insurer/LIST_OTHER_RATES_PENDING';
export const LIST_OTHER_RATES_REJECTED = 'insurer/LIST_OTHER_RATES_REJECTED';
export const LIST_OTHER_RATES_FULFILLED = 'insurer/LIST_OTHER_RATES_FULFILLED';

export const CREATE_INSURER = 'insurer/CREATE_INSURER';
export const CREATE_INSURER_PENDING = 'insurer/CREATE_INSURER_PENDING';
export const CREATE_INSURER_FULFILLED = 'insurer/CREATE_INSURER_FULFILLED';
export const CREATE_INSURER_REJECTED = 'insurer/CREATE_INSURER_REJECTED';

export const LIST_INSURERS = 'insurer/LIST_INSURERS';
export const LIST_INSURERS_PENDING = 'insurer/LIST_INSURERS_PENDING';
export const LIST_INSURERS_REJECTED = 'insurer/LIST_INSURERS_REJECTED';
export const LIST_INSURERS_FULFILLED = 'insurer/LIST_INSURERS_FULFILLED';

export const LIST_INSURERS_PREMIUMS = 'insurer/LIST_INSURERS_PREMIUMS';
export const LIST_INSURERS_PREMIUMS_PENDING = 'insurer/LIST_INSURERS_PREMIUMS_PENDING';
export const LIST_INSURERS_PREMIUMS_REJECTED = 'insurer/LIST_INSURERS_PREMIUMS_REJECTED';
export const LIST_INSURERS_PREMIUMS_FULFILLED = 'insurer/LIST_INSURERS_PREMIUMS_FULFILLED';

export const UPDATE_INSURER = 'insurer/UPDATE_INSURER';
export const UPDATE_INSURER_PENDING = 'insurer/UPDATE_INSURER_PENDING';
export const UPDATE_INSURER_FULFILLED = 'insurer/UPDATE_INSURER_FULFILLED';
export const UPDATE_INSURER_REJECTED = 'insurer/UPDATE_INSURER_REJECTED';

export const listOtherRates = (insurer) => {
    const payload = getOtherRates(insurer);
    return {
        type: LIST_OTHER_RATES,
        payload
    }
}

export const listInsurers = () => {
    const payload = getInsurers();
    return {
        type: LIST_INSURERS,
        payload
    }
}

export const listInsurerPremiums = () => {
    const payload = getInsurersPremium();
    return {
        type: LIST_INSURERS_PREMIUMS,
        payload
    }
}

export const saveInsurer = (insurer) => {
    const payload = createInsurer(insurer);
    return {
        type: CREATE_INSURER,
        payload
    }
}

export const updateInsurer = (insurer) => {
    const payload = editInsurer(insurer);
    return {
        type: UPDATE_INSURER,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/insurers.js